'use client';

import { createContext } from 'react';

import { NormalizedEntity } from '@ravago/shared/page-data/models/contentful-mapped';

export interface PageRendererContextProps {
   isConsumer: boolean;
   locale: string;
   contentEntity: NormalizedEntity | null;
   acceptWebp: boolean;
   assetBasePath: string;
}

export const PageRendererContext = createContext<PageRendererContextProps | null>({
   isConsumer: true,
   locale: '',
   contentEntity: null,
   acceptWebp: false,
   assetBasePath: ''
});
